import type { ClientChat } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineChatApi } from '@/features/api/hooks/grapevine-chat/useGrapevineChatApi';
import { useAuth } from '@/features/authorization/provider/useAuth';
import { BadgeKey, useBadgeStore } from '@/shared/store/useBadgeStore';

export const useGetOwnChats = () => {
  const { isAuthenticated } = useAuth();
  const api = useGrapevineChatApi();

  const updateBadge = useBadgeStore((state) => state.updateBadge);

  const query = useQuery<ClientChat[]>({
    queryKey: [API_CACHE_KEYS.OWN_CHATS],
    queryFn: () => api.getOwnChats(),
    enabled: isAuthenticated
  });

  const unreadMessageCount = query.data?.reduce(
    (sum, chat) => sum + (chat.unreadMessageCount ?? 0),
    0
  );

  useEffect(() => {
    if (unreadMessageCount === undefined) return;

    updateBadge(
      BadgeKey.Chat,
      unreadMessageCount === 0 ? undefined : unreadMessageCount
    );
  }, [unreadMessageCount, updateBadge]);

  return query;
};
